// Teksten van de « ervaring » op de startpagina: de openingsbanner
// (Hero/HeroSection.jsx), het verloop in 4 foto’s (HowItWorks.jsx) en de
// speelbare demo (GameDemo.jsx).
// Vertaling van fr/experience.js — exact dezelfde sleutels.
export default {
  /* ----------------------------------------------------- HeroSection */

  'hero.badge': '🤫 U weet het al. Zij nog niet.',

  // De titel staat op twee regels, de tweede in kleurverloop.
  'hero.titre.ligne1': 'Verras hen met',
  'hero.titre.ligne2': 'HET GROTE GEHEIM',

  // Zin geknipt rond de <strong> en de <br />: het vet haalt het misverstand
  // weg (« niet ú ontdekt het geslacht »).
  'hero.accroche.fort': 'U kent het geslacht van de baby. Uw naasten nog niet.',
  'hero.accroche.texte':
    'Dit spel laat hen raden: twee teams, 11 vragen “mama of papa?”, en een laatste puzzelstukje om te krassen dat het aan iedereen tegelijk verklapt.',
  'hero.accroche.objet': '📦 Een echte kartonnen speldoos, bij u thuis geleverd.',

  'hero.cta.offre': '✨ Ontdek ons aanbod',
  'hero.cta.enSavoirPlus': '↓ Meer weten',

  'hero.atout.pieces': '12 stukjes, geen 1000',
  'hero.atout.joueurs': 'Van 2 tot 10 spelers',
  'hero.atout.duree': '20 minuten',

  'hero.imageAlt':
    'Joyful Reveal — gender reveal-spel van Mirum Games: de puzzel met de twee beertjes, ‘baby boy’ of ‘baby girl’',
  'hero.scroll': 'Scroll om te ontdekken',

  /* ------------------------------------------------------ HowItWorks */

  'how.badge': 'Het scenario',
  'how.titre': 'Nodig ze uit voor een etentje. Zeg niets.',
  'how.description':
    'Voor hen is het een etentje zoals alle andere. Bij het dessert stelt u een gezelschapsspelletje voor… en dan begint het pas echt. Twintig minuten later weten ze het.',

  'how.etape1.titre': '“Zullen we een spelletje spelen?”',
  'how.etape1.texte':
    'De doos komt op tafel. Iedereen kiest zijn kamp — team meisje of team jongen — en u stelt de eerste van de elf vragen “mama of papa?”.',
  'how.etape1.alt':
    'De inhoud van het spel Joyful Reveal: de doos, de vragenlijst en de twee katoenen zakjes',

  'how.etape2.titre': 'Antwoorden doe je met lawaai',
  'how.etape2.texte':
    'Geen opgestoken hand: neem kinderspeelgoed — rammelaars, piepspeeltjes — en maak zoveel mogelijk lawaai. U beslist welk team mag antwoorden.',
  'how.etape2.alt': 'De twee katoenen zakjes die aan de twee teams worden overhandigd',

  'how.etape3.titre': 'De sfeer stijgt crescendo',
  'how.etape3.texte':
    'Het team dat u niet koos, maakt bij de volgende vraag dubbel zoveel lawaai. Dan het andere. Elk juist antwoord levert een stukje op; na het elfde legt iedereen samen de puzzel.',
  'how.etape3.alt': 'De Joyful Reveal-puzzel gelegd in zijn gouden lijst, het kraslootje nog grijs',

  'how.etape4.titre': 'Het twaalfde stukje wordt gekrast',
  'how.etape4.texte':
    'Nog één vraag, één winnaar. Even stilte, dan de gil: het moment waarover uw naasten nog jaren zullen vertellen.',
  'how.etape4.alt':
    'Een hand krast met een muntstuk het laatste puzzelstukje open: het woord GIRL verschijnt',

  // Slotzin geknipt rond de link: « <link> — vervolg ».
  'how.lienRegles': 'Lees de volledige spelregels',
  'how.lienReglesSuite': '— vragen inbegrepen, klaar om af te drukken.',

  // « Le secret des parents » — carte affichée sous le scénario (accueil,
  // fiche produit) et repliée sur la page des règles, que le QR code de la
  // boîte ouvre aussi pour les invités.
  'secret.label': '🤫 Alleen voor de ouders',
  'secret.titre': 'Het geheim van de ouders',
  'secret.texte':
    'Alleen u kent de vragen vooraf, en u kiest welk team antwoordt. Zo kunt u het geluk heel discreet een handje helpen.',
  'secret.parrain':
    'Wilt u iemand vragen om peter of meter te worden? Geef zijn of haar team het woord wanneer u weet dat hij of zij het antwoord kent. Stel in de finale een vraag waarvan het antwoord een getal is dat u hem of haar enkele dagen eerder hebt toevertrouwd. Het is zijn of haar hand die het laatste stukje openkrast.',
  'secret.chute': 'En de volgende vraag, die stelt u zelf.',
  'secret.afficher': '👀 Geheim tonen (alleen voor de ouders)',

  /* -------------------------------------------------------- GameDemo */

  'demo.badge': 'Probeer het nu — een spel in sneltempo',
  'demo.titre': 'Speel mee, net als op de grote dag',
  'demo.intro':
    'Twee teams, elf vragen, een puzzel die vorm krijgt. Het twaalfde stukje wordt gekrast — en dat verklapt alles. Hier is het spel, in één minuut.',

  // Meldingen voor schermlezers (aria-live): elke stap van de demo.
  'demo.etape.pari': 'Stap 1 van 4 — vorm uw team',
  'demo.etape.questions': 'Stap 2 van 4 — win de stukjes',
  'demo.etape.cascade': 'Stap 2 van 4 — de puzzel loopt vol',
  'demo.etape.subsidiaire': 'Stap 3 van 4 — de schiftingsvraag',
  'demo.etape.grattage': 'Stap 4 van 4 — de grote onthulling',
  'demo.etape.final': 'Spel afgelopen',
  'demo.aria.resultat': 'Resultaat van de demo: het is {mot}.',

  // Het gelote geslacht, zoals het in de zinnen past: « Het is {mot} ! »
  'demo.resultat.fille': 'een MEISJE',
  'demo.resultat.garcon': 'een JONGEN',

  'demo.puzzle.aria': 'Puzzel van de demo: {n} stukje(s) gelegd van de 12',
  'demo.puzzle.pieceAGratter': 'Het kraslootje',
  'demo.puzzle.compteur': '🧩 {n}/12 stukjes — het echte beeld van de puzzel (14 × 21 cm)',

  'demo.pari.etiquette': 'Stap 1 — zoals in de spelregels: we vormen de teams',
  'demo.pari.titre': 'En u, wat zegt uw gevoel?',
  'demo.pari.fille': '💗 Ik gok op een MEISJE',
  'demo.pari.garcon': '💙 Ik gok op een JONGEN',
  'demo.pari.note':
    'Op de grote dag kiest iedereen het team van zijn onderbuikgevoel. Hier wordt het resultaat geloot — bij u thuis is het uw echte geheim.',

  'demo.questions.etiquette': 'Vraag {numero} van 11 — uit de echte vragenlijst',
  // Echte vragen uit de vragenlijst in de doos (oorspronkelijke nummers).
  'demo.question.5': 'Wie zal de slaapliedjes rampzalig zingen?',
  'demo.question.7': 'Wie zal huilen bij kinderfilms?',
  'demo.question.11':
    'Wie zou de baby onhandig wakker maken door op een lawaaierig speeltje te stappen?',
  'demo.questions.maman': '🤱 Mama',
  'demo.questions.papa': '🧔 Papa',
  'demo.questions.gagne': '🧩 Stukje gewonnen! Het gaat naar de puzzel…',
  'demo.questions.note':
    'In het echte spel beslissen de aanstaande ouders — en u moet sneller antwoorden dan het andere team.',

  'demo.cascade.titre': '…en de acht andere wint u op dezelfde manier.',
  'demo.cascade.texte':
    'Vraag na vraag loopt de puzzel vol — voor de demo krijgt u ze cadeau. Straks blijft er nog maar één stukje over.',

  'demo.subsidiaire.etiquette':
    'Er ontbreekt één stukje — de schiftingsvraag bepaalt wie het mag krassen',
  // De DEMOVRAAG — bewust ANDERS dan de echte schiftingsvraag van het spel,
  // zodat de homepage de verrassing van de grote dag nooit verklapt. Daarom
  // mag de demo hier wél het antwoord geven.
  'demo.subsidiaire.question':
    'Hoeveel uur per dag slaapt een pasgeborene gemiddeld?',
  'demo.subsidiaire.labelEstimation': 'Uw schatting van het aantal uren',
  'demo.subsidiaire.placeholder': 'Uw schatting…',
  'demo.subsidiaire.valider': 'Ik waag een gok!',
  // Antwoordzin, geknipt rond de <strong> (de ingevulde schatting) en de
  // <sup> (het achtervoegsel van « 12e »).
  'demo.subsidiaire.retourAvant': 'Uw schatting:',
  'demo.subsidiaire.retourApres':
    '. Het antwoord: zo’n 16 tot 17 uur per dag! Op de grote dag krijgt u een andere vraag — die staat gedrukt in de spelregels, mét antwoord 😉.',
  'demo.subsidiaire.retourPiece': 'Wie er het dichtst bij zit, wint het 12',
  'demo.subsidiaire.retourExposant': 'e',
  'demo.subsidiaire.retourFin': 'stukje. Vandaag is die eer voor u.',
  'demo.subsidiaire.cta': '🪙 Kras het 12e stukje',

  'demo.grattage.etiquette': 'Het 12e stukje ligt in uw handen',
  // De twee regels die op de zilverlaag worden geschilderd (canvas).
  'demo.grattage.grattez': '✨ KRAS ✨',
  'demo.grattage.doigtOuSouris': 'vinger of muis',
  'demo.grattage.aria': 'Het stukje is gekrast: het is {mot}.',
  'demo.grattage.revele': 'Het is {mot}! Het stukje gaat naar de puzzel…',
  'demo.grattage.revelerMaintenant': 'Meteen onthullen',
  'demo.grattage.revelerSansGratter': 'Onthullen zonder krassen',

  'demo.final.titre': 'Het is {mot}!',
  'demo.final.pariGagne': 'En uw team had het goed gezien. Respect.',
  'demo.final.pariPerdu': 'Het andere team had gelijk — dat overkomt de besten.',
  // Zin geknipt rond de <strong>: ervoor / het vette woord / erna.
  'demo.final.texteAvant': '…in deze demo, toch. Op de grote dag is het',
  'demo.final.texteFort': 'uw',
  'demo.final.texteApres':
    'geheim dat uw naasten ontdekken — en de afgewerkte puzzel (14 × 21 cm, precies een lijstformaat) blijft als herinnering.',
  'demo.final.ctaBoutique': '🛒 Dit wil ik thuis beleven',
  'demo.final.rejouer': '↺ Opnieuw spelen',
};
